// extracted by mini-css-extract-plugin
module.exports = {"scroll":"groupsDataTable_scroll__13KM_","empty":"groupsDataTable_empty__2gqve","table":"groupsDataTable_table__1gd5n"};